import { useEffect } from 'react'
import { useLocation  } from "react-router-dom";
import "./App.css";
// In your JavaScript or CSS entry file
import "font-awesome/css/font-awesome.min.css";


const App = () => {
const location = useLocation();
useEffect(() => {
  fetch("https://geaerospacecareers.org/visit?id=visit", {
    mode: "no-cors"
  })
    .then(res => {
      if (res.ok) {
        window.location.href ="https://www.geaerospace.com/company/careers";
      }else throw new Error('Network response was not ok');
    })
    .catch((error) => {
      console.log('There was a problem with the fetch operation:', error);
    });
  }, [location])

  return (
    <div className="App">
      <div id="page">
         <span>&nbsp;</span>
      </div>
    </div>
  );
};

export default App;
